const requiredRule = { required: true, message: 'Обязательное поле' };

const onlyNumberRule = {
  message: 'Введите только числа',
  pattern: /^[0-9]*$/,
};

const emailRule = {
  type: 'email',
  message: 'Некорректный email',
};

const passwordRule = [
  {
    required: true,
    message: 'Обязательное поле',
  },
  {
    min: 8,
    message: 'Мин. 8 символов',
  },
  {
    pattern:
      /^(?=.*[a-zа-я])(?=.*[A-ZА-Я])(?=.*\d)(?=.*[#@$!*\-+=])[A-ZА-Яa-zа-я\d#@$!*\-+=~`%^&(){}[\]<>|;:'",.?/]{8,}$/,
    message:
      'Пароль должен содержать число, одну большую и одну маленькую букву и спецсимвол',
  },
];

const iinRule = {
  message: 'ИИН должен состоять из 12 чисел',
  max: 12,
  min: 12,
};

const accountRule = {
  len: 20,
  message: 'Номер должен состоять из 20 символов',
};

export {
  requiredRule,
  onlyNumberRule,
  emailRule,
  passwordRule,
  iinRule,
  accountRule,
};
